import React, { useEffect } from 'react'
import { BrowserRouter } from 'react-router-dom'
// import Header from './header/Header'
import AeonRoutes from './routes/Router'
import AOS from 'aos';
import 'aos/dist/aos.css';
import ScrollTop from './Hooks/Scroll-Top/ScrollTop'
import MHeader from './header/MHeader'
import MFFooter from './footer/MFFooter';

const Layout = () => {
  useEffect(() => {
    AOS.init();
  }, [])
  return (
    <BrowserRouter>
    <div>
      <ScrollTop>
        <MHeader />
        <AeonRoutes />
        {/* <Footer /> */}
        <MFFooter />
      </ScrollTop>
    </div>
  </BrowserRouter>
  )
}

export default Layout